import React from 'react';
import { useContacts } from '../../context/ContactsContext';
import { ContactCard } from './ContactCard';

export function ContactList() {
  const { contacts, selectedContact, selectContact, isLoading, showArchived } = useContacts();

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-500 p-4 text-center">
        <div>
          {showArchived ? (
            <>
              <p>No archived contacts.</p>
              <p className="text-sm mt-2">Click the archive button to see active contacts</p>
            </>
          ) : (
            <>
              <p>No contacts yet.</p>
              <p className="text-sm mt-2">Click "+ Add" to start chatting</p>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {contacts.map(contact => (
        <ContactCard
          key={contact.id}
          contact={contact}
          isSelected={selectedContact?.id === contact.id}
          onSelect={() => selectContact(contact)}
        />
      ))}
    </div>
  );
}